import makeStyles from '@mui/styles/makeStyles'
import { tokens } from '../../styles/tokens'

export const useStyles = makeStyles(theme => ({
  clientInformationDialogHeader: {
    width: '100%',
    height: 60,
    borderRadius: tokens.radius.lg,
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.contrastText,
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(0.75),
    paddingRight: theme.spacing(2),
    justifyContent: 'center',
  },
  commodityContainer: {
    borderRadius: '12px',
    border: `1px solid ${tokens.color.neutral[200]}`,
    boxShadow: 'none',
    height: '100px',
    width: '550px',
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: tokens.color.neutral[50],
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      boxSizing: 'border-box',
    },
  },
  addClientContainer: {
    height: '100px',
    width: '550px',
    marginTop: theme.spacing(1),
    display: 'flex',
    borderRadius: '12px',
    border: `1px solid ${tokens.color.neutral[200]}`,
    boxShadow: 'none',
    backgroundColor: tokens.color.neutral[50],
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      boxSizing: 'border-box',
    },
  },
  massOrderTotals: {
    height: '100px',
    width: '550px',
    marginTop: theme.spacing(1),
    display: 'flex',
    borderRadius: '12px',
    border: `1px solid ${tokens.color.neutral[200]}`,
    boxShadow: 'none',
    backgroundColor: tokens.color.neutral[50],
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      boxSizing: 'border-box',
    },
  },
  addClientButton: {
    height: '70px',
    width: '70px',
  },
  topContainer: {
    width: '100%',
    height: '50%',
    display: 'flex',
    flexDirection: 'row',
  },
  iconSize: {
    height: '25px',
    width: '45px',
    lineHeight: '25px',
    fontSize: '12px',
  },
  position: {
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  topLineText: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2),
  },
  boldText: {
    fontWeight: 'bold',
  },
  smallFont: {
    fontSize: '10px',
  },
  smallFontRed: {
    fontSize: '10px',
    fontWeight: 600,
    color: tokens.color.error[500],
  },
  textColor: {
    color: theme.palette.primary.main,
  },
  topLineSeparator: {
    flexGrow: 1,
  },
  topLineIsin: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  bottomContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'flex-end',
    width: '100%',
    height: '50%',
    alignItems: 'flex-end',
  },
  offeringPublic: {
    color: theme.palette.success.main,
  },
  offeringPrivate: {
    color: theme.palette.warning.main,
  },
  offeringUnknown: {
    color: theme.palette.text.disabled,
  },
  securityInfo: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  percentage: {
    color: theme.palette.success.main,
  },
  selectionContainer: {
    borderRadius: '12px',
    border: `1px solid ${tokens.color.neutral[200]}`,
    boxShadow: 'none',
    width: '550px',
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
    backgroundColor: tokens.color.neutral[50],
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      boxSizing: 'border-box',
    },
  },
  paperAndClearContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  clientContainer: {
    borderRadius: '12px',
    border: `1px solid ${tokens.color.neutral[200]}`,
    boxShadow: 'none',
    minHeight: '285px',
    width: '550px',
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    color: theme.palette.primary.main,
    backgroundColor: tokens.color.neutral[50],
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      boxSizing: 'border-box',
    },
  },
  clientContainerError: {
    minHeight: '305px',
    width: '550px',
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    color: theme.palette.primary.main,
    borderRadius: '12px',
    border: `1px solid ${tokens.color.neutral[200]}`,
    boxShadow: 'none',
    backgroundColor: tokens.color.neutral[50],
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      boxSizing: 'border-box',
    },
  },
  clientContainer2: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: theme.spacing(1),
    color: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },
  clientIcon: {
    height: '40px',
    width: '40px',
  },
  clientCredentialsContainer: {
    height: '55%',
    width: '200px',
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(0.5),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 'auto',
      marginLeft: 0,
      boxSizing: 'border-box',
    },
  },
  clientCredentialsRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  clientCredentials: {
    marginLeft: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
  },
  portfolioTotalsContainer: {
    height: '100%',
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
  },
  amountInputContainer: {
    height: '50%',
    flexGrow: 1,
    marginLeft: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
  },
  textSeparatorLeft: {
    marginLeft: theme.spacing(1),
  },
  massOrderClientsContainer: {
    height: '60vh',
    maxHeight: '60vh',
    overflow: 'auto',
  },
  clientOrderTotalContainer: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  autoCompleteField: {
    margin: theme.spacing(1),
  },
  clearButton: {
    height: '5px',
    width: '5px',
  },
  actionButtons: {
    width: '10%',
  },
  actionButtonsTrader: {
    width: '17%',
  },
  totalsContainer: {
    height: '100%',
    width: '100%',
  },
  totalsLabels: {
    display: 'flex',
    flexDirection: 'row',
    height: '25%',
  },

  totalsLabel: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(0.5),
    width: '50%',
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.05em',
    textTransform: 'uppercase' as const,
    color: `${tokens.color.neutral[500]} !important`,
  },
  totalsNumbers: {
    display: 'flex',
    flexDirection: 'row',
    height: '75%',
  },
  totalsNumber: {
    fontWeight: 600,
    fontVariantNumeric: 'tabular-nums',
    letterSpacing: '-0.01em',
    color: tokens.color.neutral[900],
    fontSize: '20px',
    marginLeft: theme.spacing(2),
    maxWidth: '47%',
    flexGrow: 1,
    alignContent: 'center',
    overflowWrap: 'break-word',
  },
  dropZoneBorder: {
    border: `1px dashed ${tokens.color.neutral[300]}`,
    borderRadius: tokens.radius.md,
  },
  currencySelection: {
    display: 'flex',
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(0.5),
    width: '60px',
  },
  portfolioSelection: {
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(0.5),
    width: '200px',
  },
  isin: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end',
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  flexRow90: {
    display: 'flex',
    flexDirection: 'row',
    width: '95%',
    flexGrow: 1,
  },
  centerContent: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  leftContent: {
    justifyContent: 'left',
    alignItems: 'left',
    paddingLeft: '10px',
    flexGrow: 1,
  },
  fullwidth: {
    width: '100%',
  },
  optionDisabled: {
    opacity: 0.45,
    pointerEvents: 'none',
  },
  optionNote: {
    fontSize: '10px',
    color: tokens.color.error[500],
  },
  targetMarketStop: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    margin: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1),
    borderRadius: tokens.radius.md,
    backgroundColor: tokens.color.error[100],
    color: tokens.color.error[700],
    fontSize: '12px',
    fontWeight: 600,
  },
}))
